import { webApiConvertRequest, webApiConvertResponse, webApiConvertHeaders, webApiRuntimeString } from './adapter.mjs';
import { setAbstractFetchFunc, setAbstractConvertRequestFunc, setAbstractConvertResponseFunc, setAbstractConvertHeadersFunc } from '../../runtime/http/index.mjs';
import { setAbstractRuntimeString } from '../../runtime/platform/runtime-string.mjs';

setAbstractFetchFunc(fetch);
setAbstractConvertRequestFunc(webApiConvertRequest);
setAbstractConvertResponseFunc(webApiConvertResponse);
setAbstractConvertHeadersFunc(webApiConvertHeaders);
setAbstractRuntimeString(webApiRuntimeString);
// Export a marker to prevent tree-shaking
const webApiAdapterInitialized = true;

export { webApiAdapterInitialized };
//# sourceMappingURL=index.mjs.map
